import React from "react";
import { Container } from "./Container";
import "./styles.scss";

import truncate from "../../utils/truncate";
import numberToComma from "../../utils/numberToComma";

const CardTiny = (props) => {
  const { cardLeft, cardRight, item, price, desc, photo, action, like } = props;
  return (
    <Container>
      <div className="card-item-tiny">
        <div className="card-item-body" onClick={action}>
          <div className="d-flex justify-content-between">
            <div className="heart-container">
              {like ? (
                <span style={{ color: "#0279B8" }}>
                  <i class="fa fa-heart" aria-hidden="true"></i>
                </span>
              ) : (
                <i class="fa fa-heart-o" aria-hidden="true"></i>
              )}
            </div>
            <div className="item-tiny-image-container">
              <img
                src={photo}
                className="card-item-image-container rounded"
                width="100%"
                alt="deal day"
              />
            </div>
            <div>{cardRight}</div>
          </div>
          <div>
            <p className="card-item-item-name">{truncate(item, 15)}</p>
            <p className="card-item-item-desc">{desc}</p>
            <p className="card-item-item-name">₦ {numberToComma(price)}</p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CardTiny;
